/**
 * CreditsModal
 * Usage (dans _footer.html) :
 *   <li data-component="CreditsModal">
 *     <a href="#" data-credits-open>Crédits</a>
 *     <template> ...contenu de la modale... </template>
 *   </li>
 *
 * Le contenu de la modale vit dans le <template> pour qu'il reste du HTML
 * facile à modifier (ajouter/retirer des membres) sans toucher au JS.
 */
export default class CreditsModal {
  constructor(el) {
    this.el = el;
    this.trigger = el.querySelector('[data-credits-open]');
    this.template = el.querySelector('template');
    this.lastFocus = null;

    if (!this.trigger || !this.template) return;

    this.build();
    this.bind();
  }

  build() {
    this.modal = document.createElement('div');
    this.modal.className = 'credits-modal';
    this.modal.setAttribute('aria-hidden', 'true');
    this.modal.innerHTML = `
      <div class="credits-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="credits-modal-title">
        <button class="credits-modal__close" type="button" aria-label="Fermer">
          <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.2">
            <path d="M3 3l18 18M21 3L3 21" />
          </svg>
        </button>
        <div class="credits-modal__content"></div>
      </div>
    `;

    this.dialog = this.modal.querySelector('.credits-modal__dialog');
    this.closeBtn = this.modal.querySelector('.credits-modal__close');
    this.modal
      .querySelector('.credits-modal__content')
      .appendChild(this.template.content.cloneNode(true));

    document.body.appendChild(this.modal);
  }

  bind() {
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.open();
    });

    this.closeBtn.addEventListener('click', () => this.close());

    // un clic sur le fond (hors de la boîte) ferme la modale
    this.modal.addEventListener('click', (e) => {
      if (!this.dialog.contains(e.target)) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (!this.modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'Tab') {
        // un seul élément focusable : on garde le focus sur le bouton fermer
        e.preventDefault();
        this.closeBtn.focus();
      }
    });
  }

  open() {
    this.lastFocus = document.activeElement;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('modal-open');
    this.closeBtn.focus();
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('modal-open');
    if (this.lastFocus) this.lastFocus.focus();
  }
}
